import React from 'react';
import { Form, Input } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { accountRules, passwordRules } from '../utils/validation';

/**
 * 账号登录表单组件
 * 使用验证工具函数优化代码
 */
const AccountLoginForm = React.memo(() => {
  return (
    <div>
      <div className='flex flex-col w-full'>
        <span className='text-base text-slate-800 mb-2'>账号</span>
        <Form.Item
          name="uid"
          rules={accountRules}
        >
          <Input 
            size="large" 
            placeholder="请输入账号" 
            className="rounded-lg w-full" 
          />
        </Form.Item>
      </div>
      <div className='flex flex-col w-full'>
        <span className='text-base text-slate-800 mb-2'>密码</span>
        <Form.Item
          name="pwd"
          rules={passwordRules}
          className="mb-0"
        >
          <Input.Password
            size='large' 
            placeholder="请输入密码" 
            className="rounded-lg w-full" 
          />
        </Form.Item>
      </div>
    </div>
  );
});

AccountLoginForm.displayName = 'AccountLoginForm';

export default AccountLoginForm;